module.exports = __webpack_public_path__ + "img/murloc_warrior_small.a0c4c590.png";